module.exports = __webpack_public_path__ + "media/images/icons/eye-bdfa8da00a8869627634b080716b6705.svg";